import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

const ENROLLMENT_URL = 'https://app.mowechile.cl/inscripcion/mowe';

export default function InscripcionQrPage() {
  const [qrImage, setQrImage] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    void QRCode.toDataURL(ENROLLMENT_URL, {
      width: 900,
      margin: 2,
      color: { dark: '#172111', light: '#ffffff' },
      errorCorrectionLevel: 'H',
    }).then(setQrImage);
  }, []);

  const copyLink = async () => {
    await navigator.clipboard.writeText(ENROLLMENT_URL);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  const downloadQr = () => {
    if (!qrImage) return;
    const link = document.createElement('a');
    link.href = qrImage;
    link.download = 'qr-inscripcion-mowe.png';
    link.click();
  };

  return (
    <main className="min-h-screen bg-[#f5f4f1] text-slate-900 p-5 grid place-items-center">
      <section className="w-full max-w-xl rounded-3xl bg-white border border-gray-200 shadow-sm overflow-hidden">
        <header className="p-6 md:p-8 border-b border-gray-100 text-center">
          <h1 className="text-3xl md:text-4xl font-extrabold">Inscripción Mowe</h1>
          <p className="text-gray-500 mt-2">Escanea el código para comenzar la inscripción.</p>
        </header>
        <div className="p-6 md:p-9">
          <div className="aspect-square max-w-sm mx-auto rounded-3xl border border-gray-200 p-4 bg-white flex items-center justify-center">
            {qrImage
              ? <img src={qrImage} alt="Código QR para inscripción en Mowe" className="w-full h-full" />
              : <i className="ri-loader-4-line animate-spin text-5xl text-[#314a25]" />}
          </div>
          <p className="mt-6 px-4 py-3 rounded-xl bg-gray-50 text-sm text-gray-600 text-center break-all">{ENROLLMENT_URL}</p>
          <div className="grid sm:grid-cols-2 gap-3 mt-4">
            <button type="button" onClick={() => void copyLink()} className="px-4 py-3 rounded-xl border border-gray-300 font-semibold text-gray-700">
              <i className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} mr-2`} />{copied ? 'Copiado' : 'Copiar enlace'}
            </button>
            <button type="button" disabled={!qrImage} onClick={downloadQr} className="px-4 py-3 rounded-xl bg-[#314a25] text-white font-semibold disabled:opacity-50">
              <i className="ri-download-2-line mr-2" />Descargar QR
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}
